import moment from 'moment-timezone';

function scheduleTypesOptions(startTime, endTime, name, daysSelected, daysPerWeek) {
  const options = [];
  if (!startTime || !endTime) return options;

  const duration = endTime.diff(startTime, 'hours', true);
  const isPM = (time) => time.format('a') === 'pm';
  const normalizeName = name ? name.replace(/\s+/g, '').toLowerCase() : '';

  const cutoffHalfDay = moment('1:30 pm', 'h:mm a');
  const dropoffEarly = moment('8:30 am', 'h:mm a');
  const pickupLate = moment('5:00 pm', 'h:mm a');
  const endStandard = moment('6:00 pm', 'h:mm a');

  // Core time-based options
  if (duration > 6) options.push('Full day');
  if (endTime.isBefore(cutoffHalfDay)) options.push('Half day AM');
  if (duration < 6 && isPM(startTime) && isPM(endTime)) {
    options.push('Half day PM', 'After school');
  }

  // Dropoff/pickup times
  if (startTime.isBefore(dropoffEarly)) options.push('Early drop-off');
  if (endTime.isAfter(pickupLate)) options.push('Late pickup');
  if (endTime.isAfter(endStandard)) options.push('Evening care');

  // Overnight / extended care
  if (duration >= 23) options.push('Overnight', 'Extended hours');
  if (duration > 23) options.push('24 hour care');

  // Name-based detection
  if (normalizeName.includes('afterschool')) options.push('After school');
  if (/before\s*(school|care)/i.test(name)) options.push('Before school');

  // Shift detection
  if (duration >= 8) {
    const shiftStart2PM = moment('2:00 pm', 'h:mm a');
    const shiftStart6PM = moment('6:00 pm', 'h:mm a');

    if (!isPM(startTime)) {
      options.push('1st shift');
    } else if (startTime.isAfter(shiftStart2PM) && startTime.isBefore(shiftStart6PM)) {
      options.push('2nd shift');
    } else {
      options.push('3rd shift');
    }
  }

  // Weekend & schedule-based options
  options.push('Drop-in');
  if (daysSelected.sat || daysSelected.sun) {
    options.push('Weekend', 'Extended hours');
  }

  // Time commitment
  if (daysPerWeek >= 4 && duration >= 6) {
    options.push('Full time');
  } else {
    options.push('Half time');
  }

  return options.filter((item, index) => options.indexOf(item) === index);
}

export {
  // eslint-disable-next-line import/prefer-default-export
  scheduleTypesOptions,
};
